import { Injectable, inject, signal } from '@angular/core'
import { IndicativeOfferRequest } from '../models/indicative-offer-request'
import { environment } from '../../../environments/environment'
import { HttpClient, HttpContext } from '@angular/common/http'
import { SPINNER_MESSAGE } from '../interceptors/loading-spinner.interceptor'
import { map, Observable, of } from 'rxjs'
import { RequestMappingService } from './request-mapping.service'
import { ContactFormControls, GeneralFormControls } from './offer-form.service'
import { FormGroup } from '@angular/forms'
import { PriceFormControls } from '../models/main-form'

@Injectable({
  providedIn: 'root',
})
export class IndicativeOfferService {
  private readonly httpClient = inject(HttpClient)
  private readonly requestMappingService = inject(RequestMappingService)

  private readonly baseUrl = environment.apiUrl
  private readonly context = {
    context: new HttpContext().set(SPINNER_MESSAGE, 'Ihre Anfrage wird übermittelt – dies kann einen Moment dauern.'),
  }

  private readonly _requestId = signal<string | null>(null)
  readonly requestId = this._requestId.asReadonly()

  sendIndicativeOfferRequest(
    generalData: FormGroup<GeneralFormControls>,
    contactData: FormGroup<ContactFormControls>,
    priceData: FormGroup<PriceFormControls>
  ): Observable<string> {
    const indicativeOfferRequest: IndicativeOfferRequest = this.requestMappingService.mapToRequest(
      generalData,
      contactData,
      priceData,
      generalData.controls.technicalResources
    )
    console.log('Mapped IndicativeOfferRequest:', indicativeOfferRequest)
    return this._requestId()
      ? of(this._requestId()!)
      : this.httpClient
          .post<IndicativeOfferResponse>(
            `${this.baseUrl}/indicative-offer-request`,
            indicativeOfferRequest,
            this.context
          )
          .pipe(
            map((response) => {
              if (!response?.requestId) {
                throw new Error('Request ID is missing in the response')
              }
              this._requestId.set(response.requestId)
              return response.requestId
            })
          )
  }
}

interface IndicativeOfferResponse {
  requestId: string
}
